module.exports = __webpack_public_path__ + "static/media/simplomus.5e0c8bbf.svg";